import { GO } from '../types';
export default {
  type: GO,
  service: 'gochain.io',
  url: 'https://rpc.gochain.io',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
